import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

const TermsOfUse = () => {
  return (
    <div 
      className="min-h-screen bg-primary flex flex-col"
      style={{
        backgroundImage: "url('/lovable-uploads/c8651ff7-9b42-42de-8d0c-3fe96c28c70f.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat"
      }}
    >
      <Navbar />
      <div className="container mx-auto px-4 py-24 flex-grow animate-slide-in-right">
        <div className="max-w-4xl mx-auto bg-primary/40 backdrop-blur-md rounded-lg p-8 text-white/90">
          <h1 className="text-4xl font-bold mb-6 text-white">Termos de Uso</h1>
          
          <div className="space-y-4">
            <section>
              <h2 className="text-2xl font-semibold mb-2">1. Aceitação dos Termos</h2>
              <p>Ao acessar e usar os serviços da AutoMate Labs, você concorda com estes termos de uso. Se você não concordar com qualquer parte destes termos, não deverá usar nossos serviços.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-2">2. Descrição dos Serviços</h2>
              <p>A AutoMate Labs fornece soluções de automação e inteligência artificial. Nossos serviços incluem:</p>
              <ul className="list-disc list-inside mt-1 ml-4">
                <li>Desenvolvimento de soluções personalizadas</li>
                <li>Consultoria em automação</li>
                <li>Suporte técnico especializado</li>
                <li>Treinamento e capacitação</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-2">3. Responsabilidades do Usuário</h2>
              <p>Ao utilizar nossos serviços, você concorda em:</p>
              <ul className="list-disc list-inside mt-1 ml-4">
                <li>Fornecer informações verdadeiras e precisas</li>
                <li>Manter a confidencialidade de suas credenciais de acesso</li>
                <li>Não usar os serviços para fins ilegais</li>
                <li>Respeitar os direitos de propriedade intelectual</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-2">4. Propriedade Intelectual</h2>
              <p>Todo o conteúdo disponibilizado em nossos serviços, incluindo mas não limitado a textos, gráficos, logos, imagens e software, é de propriedade da AutoMate Labs ou de seus fornecedores e é protegido por leis de propriedade intelectual.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-2">5. Limitação de Responsabilidade</h2>
              <p>A AutoMate Labs não será responsável por quaisquer danos indiretos, incidentais ou consequenciais decorrentes do uso ou impossibilidade de uso dos serviços.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-2">6. Modificações dos Termos</h2>
              <p>Reservamo-nos o direito de modificar estes termos a qualquer momento. As modificações entrarão em vigor imediatamente após sua publicação. O uso continuado dos serviços após tais modificações constitui sua aceitação dos novos termos.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-2">7. Lei Aplicável</h2>
              <p>Estes termos são regidos pelas leis do Brasil. Qualquer disputa relacionada a estes termos será submetida à jurisdição exclusiva dos tribunais brasileiros.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-2">8. Contato</h2>
              <p>Para questões relacionadas a estes termos de uso, entre em contato conosco através do WhatsApp ou email.</p>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsOfUse;